import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Discount} from '../classes/Discount';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class DiscountService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Discount[]> {
    return this.httpClient.get<Discount[]>(`${environment.backendApiUrl}/v1/discounts`, httpOptions);
  }

  public addOrEdit(discount: Discount): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/discounts`, discount, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/discounts/` + id, httpOptions);
  }
}
